import styled from "styled-components";
import tw from "twin.macro";

export const Wrapper = styled.div(({ isDisabled }: { isDisabled?: boolean }) => [
  tw`flex px-[0.4rem] py-[0.2rem] text-[0.5rem] min-w-0 items-center space-x-0.5 text-pink-600`,
]);

export const InputEl = styled.input(() => [
  tw`outline-0 grow min-w-0 h-full placeholder:(text-pink-200)`,
]);

export const ErrorMessage = styled.div(() => [
  tw`text-red-600 text-[0.3rem] whitespace-nowrap`,
]);

export default {Wrapper, InputEl, ErrorMessage}